<router-outlet/>
<p-toast position="bottom-right"/>
<p-toast position="top-center" key="update" [baseZIndex]="5000">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="p-3">
      <div>
        <strong>{{ message.summary }}</strong>
        <p>{{ message.detail }}</p>
      </div>
      <div class="flex justify-content-end gap-2 mt-3">
        <p-button 
          i18n-label
          label="Reload" 
          (click)="reload()" 
          size="small"
          severity="info"
        />
        <p-button 
          i18n-label
          label="Later" 
          (click)="closeFn($event)" 
          size="small" 
          text="true"
          severity="info"
        />   
      </div>   
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog />